import { DatePicker, Input, Select, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormWrapper from './FormWrapper';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { fetchSubscriptionPlanList } from '../../../store/slices/subscription-plan-slice';
import { fetchSubscriptionPaymentList } from '../../../store/slices/subscription-payment-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const SubscriptionPaymentForm = () => {const [subscriptionPlanId, setSubscriptionPlanId] = useState('');
    const [subscriptionId, setSubscriptionId] = useState('');
    const [bankName, setBankName] = useState('');
    const [transactionId, setTransactionId] = useState('');
    const [amount, setAmount] = useState('');
    const [date, setDate] = useState({
        dateValue: '',
        dateString: '',
    });

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: subscriptionPayments } = useSelector((state) => state.subscriptionPayment);
    const { data: subscriptionPlans } = useSelector((state) => state.subscriptionPlan);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchSubscriptionPaymentList());
        dispatch(fetchSubscriptionPlanList());
    }, []);

    useEffect(() => {
        console.log(MODE);
        if(MODE === 'EDIT' && subscriptionPayments.length) {
            const ID = searchParams.get('id');
            const selectedentSubscriptionPayment = subscriptionPayments.filter((item) => item.payment_id === ID);
            setSubscriptionPlanId(selectedentSubscriptionPayment[0].subscription_plan_id);
            setSubscriptionId(selectedentSubscriptionPayment[0].subscription_id);
            setBankName(selectedentSubscriptionPayment[0].bank_name);
            setTransactionId(selectedentSubscriptionPayment[0].transaction_id);
            setAmount(selectedentSubscriptionPayment[0].amount);
            setDate({ 
                dateValue: dayjs(selectedentSubscriptionPayment[0].date.split(' ')[0]), 
                dateString: selectedentSubscriptionPayment[0].date.split(' ')[0] 
            });
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, subscriptionPayments]);

    const subscriptionPlanList = subscriptionPlans.map((item) => (
        { value: item.subscription_plan_id, label: item.subscription_plan_name }
    ));

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'subscription_plan_id': subscriptionPlanId,
            'subscription_id': subscriptionId,
            'bank_name': bankName,
            'transaction_id': transactionId,
            'amount': amount,
            'date': date.dateString,
        };
        console.log(details.subscription_id)
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.payment_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/subscription_payment/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/subscription-payment-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }
        
        
    }
    const resetHandler = () => {
        setSubscriptionPlanId('');
        setSubscriptionId('');
        setBankName('');
        setTransactionId('');
        setAmount('');
        setDate('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Subscription Payment</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>Subscription Plan:</label>
                    <Select
                        placeholder="Select Subscription Plan"
                        style={{ width: '100%' }}
                        size='large'
                        onChange={(value) => setSubscriptionPlanId(value)}
                        options={subscriptionPlanList}
                        allowClear
                        {...(subscriptionPlanId && {value: subscriptionPlanId})}
                    />
                </div>
                <div className='control'>
                    <label>Subscription ID:</label>
                    <Input
                        onChange={(e) => setSubscriptionId(e.target.value)} 
                        value={subscriptionId} 
                        size='large' 
                        placeholder='Subscription ID' 
                    />
                </div>
                <div className='control'>
                    <label>Bank Name:</label>
                    <Input 
                    onChange={(e) => setBankName(e.target.value)} 
                    value={bankName}
                    size='large' 
                    placeholder='Bank Name' />
                </div>
                <div className='control'>
                    <label>Transaction ID:</label>
                    <Input 
                    onChange={(e) => setTransactionId(e.target.value)} 
                    value={transactionId}
                    size='large' placeholder='Transaction ID' />
                </div>
                <div className='control'>
                    <label>Amount:</label>
                    <Input 
                    onChange={(e) => setAmount(e.target.value)} 
                    value={amount}
                    size='large' placeholder='Amount' />
                </div>
                <div className='control'>
                <label>Date:</label>
                    <div style={{width: '100%'}}>
                        <DatePicker 
                            onChange={(date, dateString) => setDate({dateValue: date, dateString: dateString})} 
                            value={date.dateValue}
                            size='large' 
                            style={{width: '100%', borderRadius: '0.2rem'}} 
                        />
                    </div>
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default SubscriptionPaymentForm;


